import { getBrandBasedIn } from "@faire/help-center-utils/serialized-data/getBrand";
import { THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES } from "@faire/web--source/common/consts/THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

const isAusBrand = () => getBrandBasedIn() === ISO3166Alpha3.AUS;

const isEurBrand = () => {
  const BrandCountry = getBrandBasedIn();
  return THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES.map(String).includes(
    BrandCountry ?? ""
  );
};

export const isAusOrEurBrand = () => isAusBrand() || isEurBrand();
